export const PACKAGE_OPTIONS = {
  directfulCore: {
    id: 'directfulCore',
    label: 'Directful core'
  },
  unlimited: {
    id: 'Unlimited',
    label: 'Directful unlimited'
  }
}

export const FIELDS_TO_REMOVE = [
  'hasSetupFee',
  'setupFee',
  'hasPremiumSupport',
  'premiumSupportFee',
  'selectedPackage',
  'monthlyRate'
]

export const componentModes = {
  paymentPeriod: 'paymentPeriod',
  switchToPrepay: 'switchToPrepay'
}
